import { Box, Image, Text } from '@chakra-ui/react';
import { InfoService, Paper, WarningBox } from 'components';
import React from 'react';
import { set } from 'lodash-es';
import { getImageUrl } from 'utils';
import { ServiceInfo } from '../types';

interface Props {
  service: ServiceInfo;
  widgetId?: string;
  message?: string;
}

export const DetailsService: React.FC<Props> = ({
  service,
  widgetId,
  message,
}) => {
  const { id, description } = service;
  return (
    <Box w="100%">
      <Box>
        {widgetId && (
          <Image
            w="100%"
            maxH="306px"
            objectFit="cover"
            borderRadius="lg"
            src={getImageUrl(widgetId, 'Service', id)}
            loading="eager"
            alt=""
            onError={(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
              set(event.target, ['style', 'display'], 'none');
            }}
          />
        )}
        <Box w="100%">
          {message && <WarningBox mt={{ base: 4, md: 14 }} message={message} />}
          <Box>
            <Text color="black" textStyle="h4" my="4">
              Информация
            </Text>
            <Paper>
              <InfoService service={service} />
            </Paper>
          </Box>
          {description && (
            <Box>
              <Text color="black" textStyle="h4" my="4">
                Описание
              </Text>
              <Paper>
                <Text
                  color="black"
                  textStyle="body1"
                  lineHeight="5"
                  whiteSpace="pre-wrap"
                  translate="no"
                >
                  {description}
                </Text>
              </Paper>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
